// This is generated code from apps/website/svgs.ts.
// To regenerate this, run `nx build-svgs website`

export const PICTOGRAMS_REMOTE_SPRITE_URL =
    '/pictograms-sprite-54f2b09e3a358a1e1a4491c7843c2e351c1132041fbca0f594e2d7c883a93d67.svg';
